export interface CognitoUserInfo {
  profile?: string;
  given_name: string;
  family_name: string;
  email: string;
  "cognito:username": string;
  "custom:location": string;
  "custom:manager": string;
  "custom:alias": string;
  "custom:jobDescription": string;
}
export interface User {
  id: string;
  givenName: string;
  familyName: string;
  email: string;
  roles: Role[];
  siteCode: string;
  managerAlias?: string;
  jobDescription?: string;
}

export enum Role {
  WC_CLAIM_USER_LIMITED = "wc-claim-user-limited",
  WC_CLAIM_USER = "wc-claim-user",
  WC_CLAIM_PRODUCT_GROUP = "wc-claim-pm",
  CARGO_CLAIM_USER = "cargo-claim-intake-users",
  IPL_CLAIM_USER = "ipl-claim-user",
  WC_CLAIM_CANADA_USER = "wc-claim-canada-user",
}

export const ROLE_DISPLAY_NAME: { [key: string]: string } = {
  [Role.WC_CLAIM_USER_LIMITED]: "WHS Limited User Role",
  [Role.WC_CLAIM_USER]: "WHS User Role",
  [Role.WC_CLAIM_PRODUCT_GROUP]: "Product Group User Role",
  [Role.CARGO_CLAIM_USER]: "Cargo User Role",
  [Role.IPL_CLAIM_USER]: "IPL User Role",
  [Role.WC_CLAIM_CANADA_USER]: "WHS Canada User Role",
};
